export function getdata() {
	let obj = {
		
			
			headData: [{
				title: "一季度",
				children: [{
					title: "季初",
					prop: "firstNum1",
					width: "70px",
				}, {
					title: "季末",
					prop: "lastNum1",
					width: "70px",
				}]
			}, {
				title: "二季度",
				children: [{
					title: "季初",
					prop: "firstNum2",
					width: "70px",
				}, {
					title: "季末",
					prop: "lastNum2",
					width: "70px",
				}]
			}, {
				title: "三季度",
				children: [{
					title: "季初",
					prop: "firstNum3",
					width: "70px",
				}, {
					title: "季末",
					prop: "lastNum3",
					width: "70px",
				}]
			}, {
				title: "四季度",
				children: [{
					title: "季初",
					prop: "firstNum4",
					width: "70px",
				}, {
					title: "季末",
					prop: "lastNum4",
					width: "70px",
				}]
			}, ],
			monthOneHeadData: [{
				title: "1月",
				children: [{
					title: "月初",
					prop: "firstNum1",
					width: "70px",
				}, {
					title: "月末",
					prop: "lastNum1",
					width: "70px",
				}]
			}, {
				title: "2月",
				children: [{
					title: "月初",
					prop: "firstNum2",
					width: "70px",
				}, {
					title: "月末",
					prop: "lastNum2",
					width: "70px",
				}]
			}, {
				title: "3月",
				children: [{
					title: "月初",
					prop: "firstNum3",
					width: "70px",
				}, {
					title: "月末",
					prop: "lastNum3",
					width: "70px",
				}]
			}, {
				title: "4月",
				children: [{
					title: "月初",
					prop: "firstNum4",
					width: "70px",
				}, {
					title: "月末",
					prop: "lastNum4",
					width: "70px",
				}]
			}, ],
			monthTwoHeadData: [{
				title: "5月",
				children: [{
					title: "月初",
					prop: "firstNum5",
					width: "70px",
				}, {
					title: "月末",
					prop: "lastNum5",
					width: "70px",
				}]
			}, {
				title: "6月",
				children: [{
					title: "月初",
					prop: "firstNum6",
					width: "70px",
				}, {
					title: "月末",
					prop: "lastNum6",
					width: "70px",
				}]
			}, {
				title: "7月",
				children: [{
					title: "月初",
					prop: "firstNum7",
					width: "70px",
				}, {
					title: "月末",
					prop: "lastNum7",
					width: "70px",
				}]
			}, {
				title: "8月",
				children: [{
					title: "月初",
					prop: "firstNum8",
					width: "70px",
				}, {
					title: "月末",
					prop: "lastNum8",
					width: "70px",
				}]
			}, ],
			monthThreeHeadData: [{
				title: "9月",
				children: [{
					title: "月初",
					prop: "firstNum9",
					width: "70px",
				}, {
					title: "月末",
					prop: "lastNum9",
					width: "70px",
				}]
			}, {
				title: "10月",
				children: [{
					title: "月初",
					prop: "firstNum10",
					width: "70px",
				}, {
					title: "月末",
					prop: "lastNum10",
					width: "70px",
				}]
			}, {
				title: "11月",
				children: [{
					title: "月初",
					prop: "firstNum11",
					width: "70px",
				}, {
					title: "月末",
					prop: "lastNum11",
					width: "70px",
				}]
			}, {
				title: "12月",
				children: [{
					title: "月初",
					prop: "firstNum12",
					width: "70px",
				}, {
					title: "月末",
					prop: "lastNum12",
					width: "70px",
				}]
			}],
			tableData: [{
				firstNum1: '0',
				lastNum1: '0',
				firstNum2: '0',
				lastNum2: '0',
				firstNum3: '0',
				lastNum3: '0',
				firstNum4: '0',
				lastNum4: '0',
			}],
			tableDataone: [{
				firstNum1: '0',
				lastNum1: '0',
				firstNum2: '0',
				lastNum2: '0',
				firstNum3: '0',
				lastNum3: '0',
				firstNum4: '0',
				lastNum4: '0',
			}],
			tableDatatwo: [{
				firstNum5: '0',
				lastNum5: '0',
				firstNum6: '0',
				lastNum6: '0',
				firstNum7: '0',
				lastNum7: '0',
				firstNum8: '0',
				lastNum8: '0',
			}],
			tableDatathree: [{
				firstNum9: '0',
				lastNum9: '0',
				firstNum10: '0',
				lastNum10: '0',
				firstNum11: '0',
				lastNum11: '0',
				firstNum12: '0',
				lastNum12: '0',
			}]
	}
	return obj
}
